module.exports = __webpack_public_path__ + "img/16.RoyalEnfield2012.61cdba52.png";